import { FaArrowRight } from "react-icons/fa6"
import { PropTypes } from 'prop-types';

const BtnLink = ({text,file}) => {
    return (
        <a href={file?file:'#'} download={file} target="_blank" rel="noreferrer" className="px-8 py-4 w-fit rounded border border-blue-700 text-blue-700 justify-center items-center gap-4 flex">
            <span className="text-xs md:text-base  whitespace-normal font-bold capitalize flex items-center gap-3">{text} <FaArrowRight /></span>
        </a>
    )
}
BtnLink.propTypes = {
    text: PropTypes.string,
    file: PropTypes.string
}
export default BtnLink